export default "__VITE_ASSET__CWKl9AEL__"